export const config = {
    baseApiUrl: process.env.VUE_APP_API_WOOCOMMERCE_BASE_URL,
    apiKeyQuery: process.env.VUE_APP_API_WOOCOMMERCE_KEY_QUERY,
    loginUrl: process.env.VUE_APP_API_WOOCOMMERCE_LOGIN_URL,
    defaultPerPage: 10
};
